import { atom } from 'jotai';

export const affiliateGoodsFloatingAtom = atom(false);
